/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/define-messages
import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'platform.ui.favouriting.favourite-change-provider.flags.failure.title',
		defaultMessage: 'Something’s gone wrong',
		description: 'Title explaining that there was an error',
	},
	description: {
		id: 'platform.ui.favouriting.favourite-change-provider.flags.failure.description',
		defaultMessage: 'You cannot star items right now due to an error.',
		description:
			'Text to describe that there was an error trying to perform an action with the server (e.g. starring or unstarring an item)',
	},
});

export const errorFlag = (): {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	type: string;
} => ({
	type: 'error',
	...messages,
});
